import { defineMessages } from 'react-intl'

export default defineMessages({
  'ConfirmBilling.title': {
    id: 'title',
    defaultMessage: 'Confirm Billing Details',
  },
  'ConfirmBilling.form_address': {
    id: 'form_address',
    defaultMessage: 'Address',
  },
  'ConfirmBilling.form_city': {
    id: 'form_city',
    defaultMessage: 'City',
  },
  'ConfirmBilling.form_country': {
    id: 'form_country',
    defaultMessage: 'Country',
  },
  'ConfirmBilling.form_postal_code': {
    id: 'form_postal_code',
    defaultMessage: 'ZIP/Postal Code',
  },
  'ConfirmBilling.form_province': {
    id: 'form_province',
    defaultMessage: 'State/Province',
  },

  'ConfirmBilling.remember': {
    id: 'remember',
    defaultMessage: 'Remember me *',
  },
  'ConfirmBilling.remember_hint': {
    id: 'remember_hint',
    defaultMessage: '*You will be able to change your billing info in My Account page ("$" symbol)',
  },
})
